<template>
  <div>
    <add-article-category-sidebar
      :isSidebarActive="isAddCategorySidebarActive"
      @closeSidebar="toggleAddCategorySidebar"
      :data="addCategorySidebarData"
    />

    <edit-article-category-sidebar
      :isSidebarActive="isEditCategorySidebarActive"
      @closeSidebar="toggleEditCategorySidebar"
      :data="editCategorySidebarData"
    />

    <h3>Content</h3>
    <div style="position: absolute; right: 60px; margin-top: -25px">
      <vs-button type="border" @click="confirmDeleteCategory()"
        >Delete Category</vs-button
      >
      <vs-button class="ml-2" type="border" @click="toggleEditCategorySidebar()"
        >Edit Category</vs-button
      >
      <vs-button class="ml-2" type="border" @click="toggleAddCategorySidebar()"
        >Add Category</vs-button
      >
    </div>

    <div :key="forceRender">
      <vs-button class="mt-8" type="border" @click="showOrderCategoryPopup()"
        >Rearrange</vs-button
      >

      <vs-tabs
        v-if="articleCategories.length > 0"
        v-model="categoryIndex"
        :position="isSmallerScreen ? 'top' : 'left'"
        class="tabs-shadow-none mt-2"
        id="profile-tabs"
        :key="isSmallerScreen"
      >
        <!-- ARTICLE CATEGORIES -->
        <vs-tab
          v-for="category in articleCategories"
          :key="category.articleCategoryId"
          icon-pack="feather"
          icon="icon-send"
          :label="!isSmallerScreen ? $translate(category.title) : ''"
        >
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <article-list :articleCategoryInstance="category" />
          </div>
        </vs-tab>
      </vs-tabs>
    </div>

    <vs-popup
      title="Rearrange Order"
      :active.sync="orderCategoryPopupActive"
    >
      <div>
        <draggable
          v-model="categoryOrderItems"
          class="list-group list-group-flush cursor-move"
          tag="ul"
        >
          <transition-group
            type="transition"
            name="flip-list"
          >
            <li
              v-for="listItem in categoryOrderItems"
              :key="listItem.articleCategoryId"
              class="category-list-item"
              tag="li"
            >
              <div class="d-flex">
                <div class="ml-25">
                  <p>{{$translate(listItem.title)}}</p>
                </div>
              </div>
            </li>
          </transition-group>
        </draggable>

        <vs-button 
          @click="updateCategoryOrder"
          class="mt-10"
          color="primary" type="filled" icon-pack="feather" icon="done">
          Save
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

import ArticleList from "./ArticleList.vue";
import AddArticleCategorySidebar from "./components/AddArticleCategorySidebar.vue";
import EditArticleCategorySidebar from "./components/EditArticleCategorySidebar.vue";

export default {
  components: {
    draggable,

    ArticleList,
    AddArticleCategorySidebar,
    EditArticleCategorySidebar,
  },
  watch: {
    articleCategories (/*val*/) {
      this.forceRender += 1
    }
  },
  data() {
    return {
      forceRender: 0,

      categoryIndex: 0,
      articleCategoryId: null,

      isEditCategorySidebarActive: false,
      editCategorySidebarData: {
        articleCategoryId: "",
        title: "",
        description: "",
        imageUrls: [],
        tags: [],

        isSubmitted: false,
      },

      isAddCategorySidebarActive: false,
      addCategorySidebarData: {
        title: "",
        description: "",
        tags: [],

        isSubmitted: false,
      },

      articleCategories: [],

      categoryOrderItems: [],
      orderCategoryPopupActive: false
    };
  },
  methods: {
    showOrderCategoryPopup: function () {
      this.categoryOrderItems = this.articleCategories.map(a => { 
        return {
          articleCategoryId: a.articleCategoryId, 
          title: a.title
        }
      });

      this.orderCategoryPopupActive = true
    },
    updateCategoryOrder: function () {
      this.orderCategoryPopupActive = false

      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/ArticleCategories/order";

      const payload = {
        categoryIds: this.categoryOrderItems.map(a => a.articleCategoryId)
      }
      this.$http
        .put(url, payload)
        .then((/*resp*/) => {
          this.getArticleCategories()
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    goToLinkedCategory: function () {
      if (this.articleCategoryId && this.articleCategoryId !== null) {
        this.categoryIndex = this.articleCategories.findIndex(
          (x) => x.articleCategoryId === this.articleCategoryId
        );
      }
    },

    getArticleCategories: function () {
      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/ArticleCategories?query=*";

      this.$http
        .get(url)
        .then((resp) => {
          this.articleCategories = resp.data;

          this.goToLinkedCategory();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    confirmDeleteCategory() {

      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete the Category?',
        accept: this.deleteItem
      })
      },
      deleteItem() {
        const url = process.env.VUE_APP_API +
          '/ArticleCategories/' + this.articleCategories[this.categoryIndex].articleCategoryId;

        this.$http.delete(url)
          .then((/*resp*/) => {
            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Category deleted'
            });

          this.categoryIndex = 0;

          this.getArticleCategories();
          })
          .catch(err => {
            console.log(err)

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not delete Category: ' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close()
          })
      },

    editCategory: function () {
      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/ArticleCategories/" + this.articleCategories[this.categoryIndex].articleCategoryId;

      const payload = {
        title: this.editCategorySidebarData.title,
        description: this.editCategorySidebarData.description,
        tags: this.editCategorySidebarData.tags,
      };

      this.editCategorySidebarData = {
        articleCategoryId: this.articleCategories[this.categoryIndex].articleCategoryId,
        title: "",
        description: "",
        imageUrls: [],
        tags: [],

        isSubmitted: false,
      };

      this.$http
        .put(url, payload)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Article Category updated",
          });

          this.getArticleCategories();
        })
        .catch((err) => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not update Article Category: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    addCategory: function () {
      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/ArticleCategories";

      const payload = {
        title: this.addCategorySidebarData.title,
        description: this.addCategorySidebarData.description,
        tags: this.addCategorySidebarData.tags,
      };

      this.addCategorySidebarData = {
        title: "",
        description: "",
        tags: [],

        isSubmitted: false,
      };

      this.$http
        .post(url, payload)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Article Category added",
          });

          this.getArticleCategories();
        })
        .catch((err) => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not add Article Category: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    toggleEditCategorySidebar() {
      this.isEditCategorySidebarActive = !this.isEditCategorySidebarActive;

      if (this.editCategorySidebarData.isSubmitted === false) {
        let category = this.articleCategories[this.categoryIndex];

        this.editCategorySidebarData.articleCategoryId = category.articleCategoryId;
        this.editCategorySidebarData.title = category.title;
        this.editCategorySidebarData.description = category.description;
        this.editCategorySidebarData.imageUrls = category.imageUrls;
        this.editCategorySidebarData.tags = category.tags;

        return;
      }

      this.editCategory();
    },

    toggleAddCategorySidebar() {
      this.isAddCategorySidebarActive = !this.isAddCategorySidebarActive;

      if (this.addCategorySidebarData.isSubmitted === false) {
        return;
      }

      this.addCategory();
    },
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    }
  },

  created() {
    this.articleCategoryId = this.$route.params.articleCategoryId;

    this.getArticleCategories();
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}


#single-image-container .fileuploader-input {
  width: calc(100% - 16px) !important;
}

#single-image-container .fileuploader-item {
  width: calc(100% - 16px) !important;
}

.category-list-item {
  transition: all 0.3s;
  padding: 10px;
  border: 0px solid lightgray;
  border-radius: 5px;
  margin-bottom: 3px;
  font-weight: bold;
  background-color: lightgray;
}

</style>
